export const NAME = 'shipping';
